import * as userApi from '../../common/api/user';
import en from '../../international/translations/en';

export default function getEntitlements(values) {
  return new Promise(async(resolve, reject) => {
    try {
      await userApi.validateEmail(values.email);
      resolve();
    } catch (err) {
      if (err.status === 400) {
        window.analytics.track('Sign In Form Invalid Email', {
          reason: 'account doesn’t exist with email',
          email: values.email,
          location: values.location,
        });
        reject({
          email: en.sign_in.error_email_does_not_exist,
        });
      } else if (err.status === 504) {
        reject({
          password: ' ',
          email: ' ',
          _error: en.utils.five_hundred_four
        });
      } else {
        reject({
          password: ' ',
          email: ' ',
          _error: en.utils.five_hundred
        });
      }
    }
  });
}
